export class AccountingAccountsModel {

  id: string;
  uid: string;
  number: string;
  name: string;
  type: string;
  projectUid?: string;
  expenseProjectTypeUid?: string;

  constructor() {
  }

}

export class AccountingAccountsLedgerModel {

  index: number;
  key: string;
  debit: number;
  credit: number;
  monthbalance: number;
  balance: number;

  constructor() {
  }

}
